import authHeader from "@/services/auth/AuthHeader";
import axios from "axios";
import MathUtil from "@/util/MathUtil";

class CashAndCardService {
    createAmountForRefund(amount){
        let amountForRefund = MathUtil.displayTwoDecimals(amount).replace(',', ''); //Just remove comma
        return parseInt(amountForRefund);
    }
    refund(amount, refundedPayments, cartItems, refundedTipsAmount, orderDocumentId){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/payment/cashAndCardRefund';
        let basicAuth = authHeader();
        return axios.post(url,
            {
                merchant: user.merchant,
                amount: this.createAmountForRefund(amount),
                refundedPayments: refundedPayments,
                cartItems: cartItems,
                refundedTipsAmount : refundedTipsAmount,
                orderDocumentId: orderDocumentId
            },
            {headers: basicAuth });
    }
}

export default new CashAndCardService();
